import { useVoice } from "../../voice/store";
import { voice } from "../../voice/manager";

const LABELS = {
  idle: ["Phone off", "bg-slate-400"],
  unsupported: ["Unsupported browser", "bg-red-500"],
  connecting: ["Connecting…", "bg-amber-400"],
  ready: ["Ready", "bg-emerald-500"],
  offline: ["Offline", "bg-red-500"],
  error: ["Phone error", "bg-red-500"],
} as const;

/** Connection status of the local softphone, plus presence (Available/Away) for inbound routing. */
export function DeviceStatusBadge() {
  const { status, error, incomingAllowed, registered, presence } = useVoice();
  const [label, dot] = LABELS[status];
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-white/60 px-2.5 py-1 text-muted ring-1 ring-inset ring-white/70" role="status" title={error ?? undefined}>
        <span className={`h-2 w-2 rounded-full ${dot} ${status === "ready" ? "shadow-[0_0_0_3px_rgb(16_185_129/0.2)]" : ""}`} aria-hidden="true" />
        <span className="hidden md:inline">{label}</span>
        <span className="sr-only md:hidden">{label}</span>
      </span>
      {incomingAllowed && registered && (
        <label className="hidden items-center gap-1 sm:flex">
          <span className="sr-only">Availability</span>
          <select
            className="focus-ring h-8 rounded-full border border-white/70 bg-white/60 px-2.5 text-xs text-default backdrop-blur"
            value={presence}
            onChange={(e) => void voice.setPresence(e.target.value as "AVAILABLE" | "AWAY")}
          >
            <option value="AVAILABLE">Available</option>
            <option value="AWAY">Away (no inbound)</option>
          </select>
        </label>
      )}
    </div>
  );
}
